module.exports = __webpack_public_path__ + "static/media/AvailableXp.e7cfd107.svg";